import { render, staticRenderFns } from "./PGTokenization.vue?vue&type=template&id=75c0ab44&"
import script from "./PGTokenization.vue?vue&type=script&lang=js&"
export * from "./PGTokenization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports